import React, { useEffect, useState } from "react";
import { CaretDownOutlined } from "@ant-design/icons";
import { Col, Dropdown, Menu, Row, Space } from "antd";
import Item from "./item";
import { article } from "@Api";
import { useLocalStorageState } from "ahooks";
import { useAtom } from "jotai";
import { pkComparisonAtom } from "@Lib/jotai/pkCompare";

const { fetchStopSalesYears } = article;

interface IProps {
  data: IList[];
  onChange: (e) => void;
  setOpenPK: (e) => void;
  sumData: any;
}
export interface IList {
  data: {
    [key: string]: any;
  }[];
  title: string;
}

const KindsCompare: React.FC<IProps> = ({ data, sumData, onChange, setOpenPK }) => {
  const [navItem, setNavItem] = useState({ new: [], old: [] });
  const [navClickItem, setNavClickItem] = useState<string | number>("");
  const [competeListData, setCompeteListData] = useLocalStorageState<any>(`globalPkComparison`);
  const [globalPkList, updateGlobalPkList] = useAtom(pkComparisonAtom);

  const setCompeteListValue = (data) => {
    const { brandId, brandName, kindId, kindName, modelYearId, modelName, thumb, price, year } = data;
    const newobj = {
      brandId,
      brandName,
      kindId,
      kindName,
      myid: modelYearId,
      modelName,
      thumb,
      price,
      year
    };
    updateGlobalPkList({
      data: newobj,
      callback: (data) => {
        setCompeteListData(data)
      }
    });
    setOpenPK(true);
  };

  const getStopSalesYears = async () => {
    try {
      const res: any = await fetchStopSalesYears({ k: window.query_kind_id });
      if (res?.status === 200) {
        const { new: newData = [], old: oldData = [] } = res.data || {};
        const new_kind_id =
          newData.length > 0 ? newData[0].new_kind_id : oldData.length > 0 ? oldData[0].new_kind_id : "";
        const saleStatus = newData.length > 0 ? "onSale" : "offSale";

        // 在售优先
        newData.length > 0
          ? setNavClickItem("")
          : oldData.length > 0
            ? setNavClickItem(oldData[0])
            : setNavClickItem("");
        onChange?.({ new_kind_id, saleStatus });
        setNavItem(res?.data || []);
      }
    } catch (error) { }
  };

  useEffect(() => {
    getStopSalesYears();
  }, []);

  useEffect(() => {
    setCompeteListData(globalPkList)
  }, [globalPkList]);


  if (!navItem.new.length && !navItem.old.length) {
    return <></>;
  }

  return (
    <div className='mt-40 border-0 border-b-1 border-solid border-[#E8E8E8]'>
      <div className='flex mb-16 items-center'>
        <h2 className='text-20 mr-20 mb-0 text-[#333333] font-[600]'>
          {sumData?.brandName || ""} {sumData?.kindName || ""} 車型
        </h2>
        <div className='cursor-pointer flex items-center text-14'>
          {navItem.new.length > 0 && (
            <span
              className={`${navClickItem === "" ? "text-[#3264FF] bg-[#E6F0FF]" : "text-[#333] bg-[#F6F7FB]"} px-10 h-28 flex items-center justify-center rounded-4 mr-10`}
              onClick={() => {
                setNavClickItem("");
                onChange && onChange({ new_kind_id: (navItem.new[0] as any).new_kind_id, saleStatus: "onSale" });
              }}
            >
              在售車型
            </span>
          )}
          {navItem.old.length > 0 && (
            <Dropdown
              overlay={
                <Menu>
                  {navItem.old.map((item: any, index) => (
                    <Menu.Item
                      key={index}
                      onClick={() => {
                        setNavClickItem(item);
                        onChange && onChange({ ...item, saleStatus: "offSale" });
                      }}
                    >
                      <span className='text-[#333] cursor-pointer'>{`${item.year}年式`}</span>
                    </Menu.Item>
                  ))}
                </Menu>
              }
            >
              <div className={`${navClickItem === "" ? "text-[#333] bg-[#F6F7FB]" : "text-[#3264FF] bg-[#E6F0FF]"} px-10 h-28 flex items-center justify-center rounded-4 mr-10`}>
                停售車型
                <CaretDownOutlined className="ml-4" />
              </div>
            </Dropdown>
          )}
        </div>
      </div>

      {Array.isArray(data) &&
        data.length > 0 &&
        data.map((item, index) => (
          <React.Fragment key={index}>
            <Row className='bg-[#F2F4F9] h-40'>
              <Col span={14}>
                <div className='text-14 h-full text-[#333333] flex items-center mb-0 pl-14'>
                  <img
                    src={`https://photo.8891.com.tw/2023/09/07/${item.title.includes("油電混合")
                      ? "1694076938961066"
                      : item.title.includes("電動")
                        ? "1694076914865669"
                        : "1694076939049672"
                      }.png`}
                    alt=''
                    className='w-18 h-18 mr-4'
                  />
                  {item.title}
                </div>
              </Col>
              <Col span={10}>
                <p className='text-14 h-full text-[#333333] items-center mb-0 w-80 text-center flex justify-center'>
                  售價
                </p>
              </Col>
            </Row>

            <div>
              {item.data.length > 0 &&
                item.data.map((res: any, inx) => (
                  <Item
                    dataSource={item}
                    data={res}
                    key={inx}
                    index={inx}
                    inquiry={"綜述頁-車款一鍵詢價"}
                    competeListData={competeListData}
                    onClickCompete={(data) => setCompeteListValue(data)}
                  />
                ))}
            </div>
          </React.Fragment>
        ))}
    </div>
  );
};
export default KindsCompare;
